<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    label-position="top"
  >
    <el-row :gutter="10">
      <el-col :md="12">
        <h2>1. Select File</h2>
        <el-form-item
          prop="file"
          style="text-align: center;"
        >
          <el-upload
            ref="uploader"
            action=""
            :auto-upload="false"
            :on-change="onFileChange"
            drag
          >
            <i class="el-icon-upload" />
            <div class="el-upload__text">
              Drop file here or <em>click to upload</em>
            </div>
            <div
              slot="tip"
              class="el-upload__tip"
            >
              Import must be in a delimiter-seperated format.<br>
              (For example: Comma, Tab, Colon, Pipe, etc)
            </div>
          </el-upload>
        </el-form-item>
        <div
          v-if="form.file"
          style="text-align: center;"
        >
          <p>{{ form.file.name }}</p>
          <el-button
            type="danger"
            size="small"
            @click.native="onRemoveFile"
          >
            Remove
          </el-button>
        </div>
      </el-col>
      <el-col :md="12">
        <h2>2. Options</h2>
        <el-form-item
          label="Account"
          prop="account"
        >
          <el-autocomplete
            v-model="accountInput"
            :fetch-suggestions="querySearchAccount"
            placeholder="Enter name of Account"
            :trigger-on-focus="false"
            class="w-100"
            value-key="name"
            placement="top"
            :debounce="500"
            clearable
            @select="handleSelectAccount"
            @clear="clearAccountInput"
          />
        </el-form-item>
        <el-form-item
          label="Carrier"
          prop="carrier"
        >
          <el-autocomplete
            v-model="carrierInput"
            :fetch-suggestions="querySearchCarrier"
            placeholder="Enter name of Carrier"
            :trigger-on-focus="false"
            class="w-100"
            placement="top"
            value-key="name"
            :debounce="500"
            clearable
            @select="handleSelectCarrier"
            @clear="clearCarrierInput"
          />
        </el-form-item>
        <span
          v-if="isCarrierDefined === false"
          style="color: #f56c6c;"
        >
          This carrier is not supported, please select a different one
        </span>
        <el-form-item
          label="Key In Total Ex"
          prop="key_in_total_ex"
        >
          <el-input-number
            v-model="form.key_in_total_ex"
            controls-position="right"
            :precision="2"
            placeholder="Key In Total Ex ($)"
            class="w-100"
          />
        </el-form-item>
        <el-form-item
          label="Key In Fuel"
          prop="key_in_fuel"
        >
          <el-input-number
            v-model="form.key_in_fuel"
            controls-position="right"
            :precision="2"
            placeholder="Key In Fuel (%)"
            class="w-100"
          />
        </el-form-item>
        <el-form-item
          label="Admin Fee"
          prop="admin_fee"
        >
          <el-input-number
            v-model="form.admin_fee"
            controls-position="right"
            :precision="2"
            placeholder="Admin Fee ($)"
            class="w-100"
          />
        </el-form-item>
        <el-form-item
          label="Is Grouped"
          prop="is_grouped"
        >
          <el-switch v-model="form.is_grouped" />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      accountInput: '',
      carrierInput: '',
      isCarrierDefined: null,
      rules: {
        file: [
          { required: true, message: 'Invoice File is required', trigger: ['blur', 'change'] }
        ],
        carrier: [
          { required: true, message: 'Carrier is required', trigger: 'change' }
        ],
        key_in_total_ex: [
          { required: true, message: 'Key In Total Ex is required', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    'form.carrier': function (newVal) {
      if (newVal && newVal.name) {
        try {
          this.$sheep.getConfig(newVal.name.toLowerCase().replace(/\s/g, '').replace(/[\W_]+/g, ''))
          this.$set(this, 'isCarrierDefined', true)
        } catch {
          this.$set(this, 'isCarrierDefined', false)
        }
      } else {
        this.$set(this, 'isCarrierDefined', null)
      }
    }
  },
  methods: {
    submit () {
      this.$refs.form.validate((valid) => {
        if (valid && this.isCarrierDefined) {
          this.$emit('submitted', true)
        }
      })
    },
    onFileChange (file, fileList) {
      this.$refs.uploader.clearFiles()
      this.$set(this.form, 'file', file)
    },
    onRemoveFile () {
      this.$set(this.form, 'file', null)
    },
    querySearchAccount (queryString, cb) {
      this.$sdk.account.list(builder => {
        builder.filters = { 'account_name': queryString, 'account_active': 1 }
      }).then(res => {
        cb(res)
      })
    },
    handleSelectAccount (item) {
      this.$set(this, 'accountInput', item.name)
      this.$set(this.form, 'account', item)
    },
    clearAccountInput () {
      this.$set(this, 'accountInput', '')
      this.$set(this.form, 'account', null)
    },
    querySearchCarrier (queryString, cb) {
      this.$sdk.carrier.list(builder => {
        builder.filters = { 'carrier_name': queryString }
      }).then(res => {
        cb(res)
      })
    },
    handleSelectCarrier (item) {
      this.$set(this, 'carrierInput', item.name)
      this.$set(this.form, 'carrier', item)
    },
    clearCarrierInput () {
      this.$set(this, 'carrierInput', '')
      this.$set(this.form, 'carrier', null)
    }
  }
}
</script>

<style>

</style>
